<template>
  <div class="loading_container" v-if="error !== null">
    <div
      class="alert alert-danger m-5"
      v-if="error.errorCode === 'INVALID_ASSISTANT_STATUS' && error.errorData === 3"
    >
      Seu perfil foi desativado. Entre em contato com o suporte para maiores informações.
    </div>

    <div
      class="alert alert-danger m-5"
      v-else-if="error.errorCode === 'PROJECT_NOT_FOUND'"
    >
      O projeto que você tentou acessar não foi encontrado.
    </div>

    <div
      class="alert alert-danger m-5"
      v-else-if="error.errorCode === 'CLIENT_NOT_FOUND'"
    >
      O perfil de cliente que você tentou acessar não foi encontrado.
    </div>

    <div class="alert alert-danger m-5" v-else>
      Ocorreu um erro ao processar sua requisição. Verifique sua conexão e tente
      novamente.<br /><br />
      Se o problema persistir, por favor, contate o suporte via
      <a class="link" href="mailto:suporte@virtap.com.br" target="_blank"
        >suporte@virtap.com.br</a
      >.
    </div>
  </div>
  <router-view v-else></router-view>
</template>

<script>
export default {
  components: {},

  computed: {
    section() {
      return this.$store.state.activeSection;
    },
    error() {
      return this.$store.state.error;
    },
  },
  data() {
    return {};
  },

  methods: {},

  watch: {
    section(newValue, oldValue) {
      let title = "Virtap | Assistente";

      switch (newValue) {
        case "DashboardPage":
          title += " | Dashboard";
          break;
        case "ProfilePage":
          title += " | Meu Perfil";
          break;
        case "PlanPage":
          title += " | Planos";
          break;
        case "ProposalListPage":
          title += " | Minhas propostas";
          break;
        case "ProjectListPage":
          title += " | Vagas de trabalho";
          break;
        case "ProjectPage":
          title += " | Projeto";
          break;
        case "ClientPage":
          title += " | Cliente";
          break;
        case "VideoListPage":
          title += " | Aulas e mentorias";
          break;
        case "VideoPage":
          title += " | Aulas e mentorias | Aula";
          break;
        case "MentorshipPage":
          title += " | Aulas e mentorias | Mentoria";
          break;
        case "VideoNotFoundPage":
          title += " | Aulas e mentorias | Conteúdo não encontrado";
          break;
          break;
        case "CourseListPage":
          title += " | Cursos";
          break;
        case "CourseNotFoundPage":
          title += " | Cursos | Curso não encontrado";
          break;
        case "CoursePage_intro-av":
          title += " | Cursos | Introdução à Assistência Virtual";
          break;
        case "CoursePage_form-av":
          title += " | Cursos | Formação Completa em Assistência Virtual";
          break;
        case "ToolListPage":
          title += " | Ferramentas";
          break;
        case "CommunityPage":
          title += " | Comunidade";
          break;
        case "ContactPage":
          title += " | Contato";
          break;
      }
      document.title = title;
    },
  },
};
</script>
